import { Page, PageTitleWithBack } from '../../../components';
import { BulkOptionExclusionsForm } from './bulk-option-exclusions-form';

export const BulkOptionExclusionsPage = () => {
  return (
    <>
      <Page title="Bulk Option Exclusions">
        <PageTitleWithBack backText="Back to Admin" backUrl={'/admin'} title="Bulk Option Exclusions" />
        <BulkOptionExclusionsForm />
      </Page>
    </>
  );
};
